import React from "react";
import { Icon } from "@/components/Icon";

/* CategoryGrid — a real "View all" collection grid (PREMIUM_UI_DIRECTION §5). When the player
   taps "View all" on a shelf, this opens a full wrapped grid of that collection's tiles with a
   back affordance that returns to the lobby (and the caller preserves the scroll position +
   active search/filters). Not a cosmetic relabel — it genuinely shows every tile in the set.

   Props:
   - title: collection title (e.g. "PRYMEBET Originals")
   - subtitle: optional one-line description
   - icon (default "casino"): header chip glyph
   - count: optional count badge
   - onBack(): return to the lobby
   - children: CasinoTile elements (already aspect-correct)
   - testid */
export default function CategoryGrid({
  title,
  subtitle = null,
  icon = "casino",
  count = null,
  onBack,
  children,
  testid = "casino-category-grid",
}) {
  const items = React.Children.toArray(children).filter(Boolean);
  return (
    <div className="space-y-5" data-testid={testid}>
      <button
        type="button"
        onClick={onBack}
        data-testid="casino-category-back"
        className="inline-flex items-center gap-2 rounded-full border border-surface-border bg-surface-4 px-4 py-2 text-sm font-semibold text-meta transition-colors hover:border-border-strong hover:text-white focus-ring"
      >
        <Icon name="chevron-left" size={16} /> All games
      </button>

      <div className="flex min-w-0 items-center gap-2.5">
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-xl bg-pnr-green/12 ring-1 ring-pnr-green/20">
          <Icon name={icon} size={18} className="text-pnr-green" />
        </span>
        <h2 className="truncate font-display text-xl font-black tracking-tight text-white sm:text-2xl">{title}</h2>
        {count != null && (
          <span className="shrink-0 rounded-md bg-surface-5 px-1.5 py-0.5 text-[11px] font-black tabular-nums text-meta shadow-[inset_0_1px_3px_rgba(0,0,0,0.5)]">{count}</span>
        )}
        {subtitle && <span className="hidden text-xs font-medium text-[#71717a] sm:inline">{subtitle}</span>}
      </div>

      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6">
        {items}
      </div>
    </div>
  );
}
